// extracted by mini-css-extract-plugin
export var divider = "_vh-0";